<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">数据中心</Breadcrumb-item>
        <Breadcrumb-item>财务每日数据</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="12" :md="12">
            <Form-item label="查询日期">
              <Row>
                <Col span="11">
                  <Date-picker type="date" format="yyyy-MM-dd" placeholder="请选择日期" value-format="yyyy-MM-dd"
                               @on-change="dateChange" />
                </Col>
              </Row>
            </Form-item>
          </Col>
        </Row>
        <Row>
        </Row>
      </Form>

      <div class="button-container">
        <Button class="left-button" type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                @click="search">搜索
        </Button>

        <div class="spacer"></div>

      </div>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/dataCenter/financeDailyList"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>

<script>
export default {
  components: {},
  name: 'financeDailyList',
  data() {
    return {
      exportLoading: false,
      searchLoading: false,
      reload: 0,
      queryParam: {
        date: null,
        studyConsultantId: null
      },
      title: [
        {
          title: '统计日期',
          // width: 150,
          align: 'center',
          key: 'date'
        },
        {
          title: '数据类型',
          // width: 120,
          align: 'center',
          key: 'dataType'
        },
        /* {
          title: '地址',
          // width: 120,
          align: 'center',
          key: 'url'
        }, */
        {
          title: '操作',
          // width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            if (row.url !== '') {
              return h('div', [
                h('a', {on: {click: () => this.download(row.date, row.url)}}, '下载')
              ])
            }
          }
        }
      ]
    }
  },
  mounted: function () {
    this.init()
  },
  created: function () {
    this.init()
  },
  methods: {
    init() {

    },
    dateChange(val) {
      this.queryParam.date = val
    },
    download(time, url) {
      this.exportLoading = true
      let link = document.createElement('a')
      link.href = url
      link.setAttribute('download', time + '付费学生剩余课时数据.xls')
      link.click()
      link.remove()
      this.exportLoading = false
    },
    search() {
      this.reload = new Date().getTime()
    },
    onLoading(loading) {
      this.searchLoading = loading
    }
  }
}
</script>



// WEBPACK FOOTER //
// FinanceDailyList.vue?3b6c5b60